// extracted by mini-css-extract-plugin
export default {"footer":"MywKmT","standard":"_CIHii"};